export default __webpack_public_path__ + "static/media/product.92e20d2f.png";